import { GetFrontBackComparisonReqData } from "./GetFrontBackComparisonReqData";

export class GetBackOfficeTotalsByInstallationReqData extends GetFrontBackComparisonReqData {
    public currency: Date = null;
}